export default __webpack_public_path__ + "static/media/set-normal-1.452e6c64.png";